import React from 'react';
import RHCertificationDialog from './RHCertificationDialog';
import RHDeleteConfirmationDialog from './RHDeleteConfirmationDialog';
import RHEducationDialog from './RHEducationDialog';
import RHExperienceDialog from './RHExperienceDialog';
import RHProfessionalProfileDialog from './RHProfessionalProfileDialog';
import RHReferenceDialog from './RHReferenceDialog';
import RHSkillDialog from './RHSkillDialog';
import RHTrainingDialog from './RHTrainingDialog';

export default function RHCareerDialogManager({ dialog, profile, skills, skillCategories, expertiseDomains, taxonomy, loading, error, onClose, onSubmit, onDelete, onProposeSkill }) {
  if (!dialog.open) return null;
  if (dialog.mode === 'delete') return <RHDeleteConfirmationDialog open item={dialog.item} loading={loading} error={error} onClose={onClose} onConfirm={onDelete} />;
  const props = { open: true, item: dialog.item, loading, error, onClose, onSubmit };
  if (dialog.kind === 'profile') return <RHProfessionalProfileDialog open profile={profile} loading={loading} error={error} onClose={onClose} onSubmit={onSubmit} />;
  if (dialog.kind === 'experience') return <RHExperienceDialog {...props} />;
  if (dialog.kind === 'education') return <RHEducationDialog {...props} />;
  if (dialog.kind === 'skill') return <RHSkillDialog {...props} skills={skills} skillCategories={skillCategories} expertiseDomains={expertiseDomains} taxonomy={taxonomy} onPropose={onProposeSkill} />;
  if (dialog.kind === 'certification') return <RHCertificationDialog {...props} />;
  if (dialog.kind === 'reference') return <RHReferenceDialog {...props} />;
  if (dialog.kind === 'training') return <RHTrainingDialog {...props} skills={skills} />;
  return null;
}
